<template>
  <a-drawer
    :maskClosable="false"
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="分类名称" prop="categoryName">
        <a-input v-model="form.categoryName" placeholder="请输入" :maxLength="50" />
      </a-form-model-item>
      <a-form-model-item label="分类层级" prop="grade">
        <a-radio-group button-style="solid" v-model="form.grade">
          <a-radio-button :value="1"> 一级 </a-radio-button>
          <a-radio-button :value="2"> 二级 </a-radio-button>
          <a-radio-button :value="3"> 三级 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status">
        <a-radio-group button-style="solid" v-model="form.status">
          <a-radio-button :value="1"> 正常 </a-radio-button>
          <a-radio-button :value="0"> 下线 </a-radio-button>
          <!-- <a-radio-button :value="3"> 三级 </a-radio-button> -->
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="类目图标" prop="icon">
        <file-upload
          type="image"
          :defaultList="form.icon"
          :file="form.icon"
          @input="getImg($event, 'icon')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="类目图片" prop="pic">
        <file-upload
          type="image"
          :defaultList="form.pic"
          :file="form.pic"
          @input="getImg($event, 'pic')"
          :count="1"
          autoCropHeight="80"
          :isUpload="false"
          autoCropWidth="80"
        ></file-upload>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark">
        <a-textarea v-model="form.remark" placeholder="请输入" :maxLength="150" />
      </a-form-model-item>
      <a-form-model-item label="排序" prop="sort">
        <a-input v-model="form.sort" placeholder="请输入" :maxLength="20" oninput="value=value.replace(/[^\d]/g,'')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { getObj, addObj, putObj } from '@/api/declaration/declarationClassification'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        categoryName: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        grade: 1,
        parentId: 0,
        status: 1,
        sort: 99,
      },
      isShow: false,
      open: false,
      hour: [],
      hours: [],
      minute: [],
      minutes: [],
      inputVisible: false,
      inputVisibles: false,
      showLoading: false,
      rules: {
        categoryName: [{ required: true, message: '请输入的分类名称', trigger: 'blur' }],
        pic: [{ required: true, message: '请上传图片', trigger: 'blur' }],
        icon: [{ required: true, message: '请类目图片', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入排序', trigger: 'blur' }],
        optionalUnit: [{ required: true, message: '请添加单位', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
    /** 上传图片成功回调 */
    getImg(info, fieldName) {
      this.form[fieldName] = info
      this.$refs.form.clearValidate(fieldName)
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        categoryName: undefined,
        pic: undefined,
        icon: undefined,
        remark: undefined,
        grade: 1,
        parentId: 0,
        status: 1,
        sort: 99,
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加商品分类'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.categoryId : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改商品分类'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(1)
          })
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>
